// Company data
export const CompanyName = 'King Liyah Minx';
export const CompanyPhoneNumber = 'Your Phone Number Here';
export const CompanyWhatsappNumber = 'Your Whatsapp Number Here';
export const CompanyEmailAddress = 'liyahminx@gmail.com';
export const DirectorName = 'King Liyah Minx';
export const LocationCity = 'Central Indiana';
export const LocationCountry = 'USA';

// Address Constants
export const AddressLine1 = 'Private Discreet Location';
export const AddressLine2 = 'Central Indiana & Surrounding States';
export const AddressLine3 = '';
export const AddressLine4 = 'USA';
export const PostalCode = ''; // Optional: keep private or omit

export const CompanyTagLine = 'BBW Ebony Superior. Sadistic Seductress. Financial Carnage Aficionado.';
export const MainTitle = 'Your Superior Femdom King in Central Indiana';
export const SubtitleMain = 'Bow to your King — submission is your new reality.';
export const SubtitleSecondary = `How will ${CompanyName} bring you financial ruin and femdom euphoria?`;

export const KeywordsPages =
  'King Liyah Minx, Central Indiana Femdom, BBW Ebony Domme, Financial Domination, Sadistic Seductress, BDSM sessions Indiana, online femdom, findom, pegging, humiliation, femdom video calls, custom femdom content, femdom text sessions, fetish lifestyle, obedient submissive training';


// Cookie data
export const NumberOfCookies = 0;
export const COOKIE_TIMER = 15000;
export const CookiePolicyName = 'CookiePolicy';

// Pages
export const INDEX_PAGE_URL = '/';
export const HOME_PAGE_URL = '/home';
export const ABOUT_PAGE_URL = '/about-me';
export const GALLERY_PAGE_URL = '/gallery';
export const SESSIONS_PAGE_URL = '/sessions';
export const FANSITES_PAGE_URL = '/fansites';
export const APPLICATION_PAGE_URL = '/application';
export const CONTACT_PAGE_URL = '/contact';
export const POLICIES_PAGE_URL = '/user-agreements';
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';
export const ERROR_404_PAGE_URL = '*';

// URL
export const FULL_BUSINESS_URL = 'https://www.liyahminx.com';
export const SHORT_BUSINESS_URL = 'liyahminx.com';
export const DISPLAY_BUSINESS_URL = 'www.liyahminx.com';
export const QUESTIONAIRE_URL = 'https://form.jotform.com/251672837696170';
export const CONTENT_FORM_URL = 'https://form.jotform.com/250257884174161';
export const SUB_APPLICATION_FORM_URL = 'https://form.jotform.com/210929197891065';

export const FETLIFE_URL = 'https://fetlife.com/users/13033943';
export const MANY_VIDS_URL = ''; // Not provided
export const THRONE_URL = 'https://throne.com/liyahminx';
export const I_WANT_CLIPS_URL = 'https://iwantclips.com/store/945598/LiyahMinx';
export const CASH_APP_URL = 'https://cash.app/$LiyahMinx';
export const X_URL = 'https://twitter.com/liyahminx'; // Formerly Twitter
export const APPLE_PAY_EMAIL = 'mailto:liyahminx@gmail.com';
export const VENMO_URL = 'https://venmo.com/code';
export const PAYPAL_URL = 'https://paypal.me/liyahminx';
export const MINTSTARS_URL = 'https://mintstars.com/tip/liyahminx';
export const WISHLIST_URL = ''; // Amazon wishlist not provided
export const ONLYFANS_URL = ''; // Not listed
export const TWITTER_URL = 'https://twitter.com/liyahminx';
export const INSTAGRAM_URL = 'https://instagram.com/kingliyahminx';
export const SNAPCHAT_URL = ''; // Not listed
export const LOYALFANS_URL = 'https://loyalfans.com/liyahminx';
export const TIKTOK_URL = ''; // Not listed
export const YOUPAY_URL = ''; // Not listed
export const SEXT_PANTHER_URL = 'https://sextpanther.com/LiyahMinx';
export const SCATBOOK_URL = ''; // Not listed
export const FEET_FINDER_URL = ''; // Not listed
export const TELEGRAM_URL = ''; // Not listed
export const ETSY_URL = ''; // Not listed
export const REDDIT_URL = 'https://www.reddit.com/u/liyahminx';

